<template>
  <div @click="openIssueDetails" class="centralized-issue-name-table-cell">
    <div class="centralized-issue-name-table-cell__name">
      {{ getName }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'IssueNameTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    enrichmentDisplayName() {
      return (this.item.metaData && this.item.metaData.enrichment && this.item.metaData.enrichment.display_name) || '';
    },
    getName() {
      // For CVE issues, prefer the enrichment display_name which contains the full CVE description
      if (this.enrichmentDisplayName) {
        return this.enrichmentDisplayName;
      }
      let name = `${this.item.displayName || this.item.name}`;
      name = name.replace(/\waf\b/, 'WAF');
      return name;
    },
  },
  methods: {
    async openIssueDetails() {
      await this.$emit('openDetailedIssuePopup', this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.centralized-issue-name-table-cell {
  &:hover {
    cursor: pointer;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: rem(20);
  &__name {
    z-index: 10;
    color: var(--text-primary);
    display: flex;
    font-family: $font-family-regular;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    &:hover {
      color: var(--brand-primary);
    }
  }
}
</style>
